import React from "react";
import image1 from "../../../assets/ecosystem-icon1.png";
import image2 from "../../../assets/ecosystem-icon2.png";
import image3 from "../../../assets/ecosystem-icon3.png";
import image4 from "../../../assets/ecosystem-icon4.png";
import soonImage from "../../../assets/soon.png";
import util1 from "../../../assets/eco-utils1.png";
import util2 from "../../../assets/eco-utils2.png";
import util3 from "../../../assets/eco-utils3.png";
import Title from "../../../components/Title";

const Ecosystem = () => {
  class DataClass {
    constructor(icon, title, desc, isSoon) {
      this.icon = icon;
      this.title = title;
      this.desc = desc;
      this.isSoon = isSoon || false;
    }
  }

  const data = [
    new DataClass(
      image1,
      "Kings Coin",
      "The token is the heartbeat of the King's ecosystem. Structured to reward & transact in gameplay."
    ),
    new DataClass(
      image2,
      "Staking",
      "Immense staking rates and multiple pools are waiting for you. Start multiplying your tokens today."
    ),
    new DataClass(
      image3,
      "Characters",
      "The future is owning the characters that you play with! Multiple NFT rarities and character options available.",
      true
    ),
    new DataClass(
      image4,
      "Video Game",
      "A complete ecosystem, with assets owned by you, all while earning additional $KINGS while you conquer the land.",
      true
    ),
  ];

  return (
    <div className="min-h-screen relative" id="ecosystem">
      <img
        src={util1}
        className="absolute top-16 w-[100px] left-[70%]"
        alt=""
      />
      <img src={util2} className="absolute top-0 w-[200px] left-[75%]" alt="" />
      <div className="container py-28">
        <Title text={"Ecosystem"} image={util3} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          {data.map((item, i) => (
            <div
              key={i}
              className="font-serif text-center flex flex-col  items-center"
            >
              <div className="relative max-w-max">
                {item.isSoon && (
                  <img
                    src={soonImage}
                    className="absolute left-full -translate-x-1/2"
                    alt=""
                  />
                )}
                <img src={item.icon} alt="" className="w-32 " />
              </div>
              <h2 className="text-3xl mb-4 ">{item.title}</h2>
              <p className="max-w-[320px] text-[#7C7F8F]">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ecosystem;
